import React from "react";
import Moment from "react-moment";
import swal from "@sweetalert/with-react";

const showInfo = props => {
  swal({
    title: "Item - Informações",
    content: (
      <div>
        <div align="center">
          <p>
            <strong>[#ID {props.id_item}]: </strong>
          </p>
          <h6 align="justify">
            <span>
              <strong>Tipo: </strong>
              {props.tipo};&nbsp;
            </span>
            <span>
              <strong>Destinatário: </strong>
              {props.destino.replace(".", " ").toUpperCase()};&nbsp;
            </span>
            <span>
              <strong>Descrição: </strong>
              {props.descricao};&nbsp;
            </span>
            <span>
              <strong>Patrimônio: </strong>
              {props.patrimonio ? props.patrimonio : "----"};&nbsp;
            </span>
            <span>
              <strong>Observação: </strong>
              {props.observacao ? props.observacao + "." : "----."}&nbsp;
            </span>
            <br/>
            <br/>
            {props.created_at !== "0000-00-00 00:00:00" && (<span>
              <strong>Registrado em: </strong>
              <Moment format="DD/MM/YYYY">
                {props.created_at}
              </Moment>.
            </span>
            )}
          </h6>
          {props.observacao_erro !== null && (
            <React.Fragment>
              <br />
              <p>
                <strong>
                  <font color="red">Erro registrado no envio do item!</font>
                </strong>
              </p>
              <h6 align="justify">
                <span>
                  <strong>Observação:</strong>&nbsp;
                  {props.observacao_erro}.
                </span>
              </h6>
            </React.Fragment>
          )}
        </div>
      </div>
    ),
    icon: "info"
  });
};

export default showInfo;
